// File: TravelDestinationsSection.jsx
// Random placeholder images + travel styling

import { Star } from 'lucide-react';
import React from 'react';

const destinations = [
  { id: 1, img: 'https://picsum.photos/400/500?random=111', name: 'City Name' },
  { id: 2, img: 'https://picsum.photos/400/500?random=222', name: 'City Name' },
  { id: 3, img: 'https://picsum.photos/400/500?random=333', name: 'City Name' },
  { id: 4, img: 'https://picsum.photos/400/500?random=444', name: 'City Name' },
  { id: 5, img: 'https://picsum.photos/400/500?random=445', name: 'City Name' },
//   { id: 6, img: 'https://picsum.photos/400/500?random=446', name: 'City Name' },
];

export default function CategoryCard2() {
  return (<>
    <section className="catc-2">
      <div className="slider-side-catc-2">
        <h3>03 /<span>04</span></h3>
      </div>

      <div className="grid-catc-2">
        {destinations.map(dest => (
          <div key={dest.id} className="card-catc-2">
            <img src={dest.img} alt="city" />
            <div className="overlay-catc-2">
              <h4>{dest.name}</h4>
              <span className="exp-catc-2">Explore Now</span>
              <div className="stars-catc-2"><Star size={20} /><Star  size={20} /><Star size={20} /><Star size={20} /><Star size={20} /></div>
            </div>
          </div>
        ))}
      </div>
    </section>
    <style>{`
/* File: TravelDestinationsSection.css */

.catc-2 {position:relative;margin-top:100px;
  padding: 60px 40px;
  display: flex;
  gap: 20px;
  align-items: flex-start;
  font-family: Inter, sans-serif;
}

.slider-side-catc-2 {
  background: rgba(144, 202, 249,1);position:absolute;top:-50px;right:0px;
  padding: 10px 10px;width:320px;height:190px;
  border-radius: 20px 0 20px 0;
  display: flex;
  justify-content: left;
  
}

.slider-side-catc-2 h3 {
  font-size: 44px;margin-top:-5px;
  font-weight: 700;
  color: #111111;
}

.slider-side-catc-2 span {
  font-size: 18px;
  margin-left: 6px;color:#222222;
  opacity: 0.7;
}

.grid-catc-2 {
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
  justify-content: left;
}

.card-catc-2 {
  position: relative;
  width: 220px;
  height: 340px;
  border-radius: 18px;
  overflow: hidden;
  cursor: pointer;
  transition: transform .3s ease;
}

.card-catc-2:hover {
  transform: translateY(-8px);
}

.card-catc-2 img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.card-catc-2:hover .overlay-catc-2 {background: rgba(0,0,0,0.6);}
.overlay-catc-2 {
  position: absolute;
  bottom: 0;
  width: 100%;
  background: rgba(0,0,0,0.3);
  padding: 14px;
  color: #fff;
  text-align: left;
  backdrop-filter: saturate(1.5) ;
}

.overlay-catc-2 h4 {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 4px;
}

.exp-catc-2 {
  font-size: 13px;
  opacity: 0.85;
  display: block;
  margin-bottom: 8px;
}

.stars-catc-2 {
  font-size: 13px;
}

@media(max-width:960px){
  .catc-2 {
    flex-direction: column; padding: 60px 10px;
    align-items: center;
  }
  .slider-side-catc-2 {
    border-radius: 10px;
    width: 100%;
    justify-content: center;
  }
    
.grid-catc-2 { align-items:center;justify-content:space-between;
  gap: 15px;
}
    .card-catc-2 {
  position: relative;
  width:47%;
  height: 250px;
  border-radius: 18px;
  overflow: hidden;
  cursor: pointer;
  transition: transform .3s ease;
}
}`}</style>
    </>
  );
}
